/* LF24: run once per [data-lhs] root (the homepage now uses several story instances) */
document.querySelectorAll('[data-lhs]').forEach(__R=>{
/* Limitless homepage story (owner-approved design, 2026-10-10). One light motion per section; CSS + IntersectionObserver only; reduced motion turns it all off. */
(() => {
  const root = __R;
  if (!root) return;
  const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  root.classList.add('lhs--js');
  if (reduce) { root.classList.add('lhs--still'); return; }

  /* scroll reveal */
  const rio = new IntersectionObserver(es => es.forEach(e => { if (e.isIntersecting) { e.target.classList.add('is-in'); rio.unobserve(e.target); } }), { rootMargin: '0px 0px -10% 0px' });
  root.querySelectorAll('.lhs-rv').forEach(el => rio.observe(el));

  /* play loops (screens, marquee) only while visible */
  const pio = new IntersectionObserver(es => es.forEach(e => e.target.classList.toggle('is-playing', e.isIntersecting)), { rootMargin: '120px 0px' });
  root.querySelectorAll('[data-lhs-play]').forEach(el => pio.observe(el));

  /* device screens: scroll the full screenshot top to bottom */
  const setReel = img => { const box = img.parentElement; const d = Math.max(0, img.offsetHeight - box.offsetHeight); img.style.setProperty('--lhs-dist', -d + 'px'); };
  root.querySelectorAll('.lhs-screen img').forEach(img => { if (img.complete) setReel(img); img.addEventListener('load', () => setReel(img)); });
  addEventListener('resize', () => root.querySelectorAll('.lhs-screen img').forEach(setReel), { passive: true });

  /* how it works: rail fills as you scroll */
  const rail = root.querySelector('[data-lhs-rail]');
  if (rail) {
    const fill = rail.querySelector('.lhs-rail i'); const steps = [...rail.querySelectorAll('.lhs-step')];
    let on = false, raf = 0;
    const paint = () => { raf = 0; const r = rail.getBoundingClientRect(); const mid = innerHeight * 0.62; const p = Math.min(1, Math.max(0, (mid - r.top) / r.height)); fill.style.transform = 'scaleY(' + p.toFixed(3) + ')'; steps.forEach(s => s.classList.toggle('is-on', s.getBoundingClientRect().top < mid)); };
    const onScroll = () => { if (on && !raf) raf = requestAnimationFrame(paint); };
    new IntersectionObserver(es => { on = es[0].isIntersecting; if (on) onScroll(); }, { rootMargin: '200px 0px' }).observe(rail);
    addEventListener('scroll', onScroll, { passive: true });
  }

  /* count-ups, once */
  const fmt = n => n.toLocaleString('en-CA');
  const cio = new IntersectionObserver(es => es.forEach(e => {
    if (!e.isIntersecting) return; cio.unobserve(e.target);
    const el = e.target, to = +el.dataset.count, suf = el.dataset.suffix || '', t0 = performance.now(), D = 1600;
    const tick = t => { const k = Math.min(1, (t - t0) / D); el.textContent = fmt(Math.round(to * (1 - Math.pow(1 - k, 3)))) + suf; if (k < 1) requestAnimationFrame(tick); };
    el.textContent = '0' + suf; requestAnimationFrame(tick);
  }), { threshold: 0.6 });
  root.querySelectorAll('[data-count]').forEach(el => cio.observe(el));
})();

/* LF11 owner 2026-10-11: (1) homepage card photo rotation, (2) reviews carousel. Separate from the block above so
   "Read more" and swiping still work with reduced motion (then: no crossfade rotation, no drift). */
(() => {
  const root = __R;
  if (!root) return;
  const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* (1) crossfade every ~3.6s; the next photo loads one step ahead and only while the card is on screen */
  if (!reduce) root.querySelectorAll('[data-lhs-rot]').forEach((box, n) => {
    let list = [];
    try { list = JSON.parse(box.querySelector('[data-lhs-rot-list]')?.textContent || '[]'); } catch (e) {}
    if (!list.length) return;
    const first = box.querySelector('img'), sizes = first?.getAttribute('sizes') || '92vw';
    let i = -1, cur = null, timer = 0, vis = false;
    const make = k => { const d = list[k]; if (d._img) return d._img; const im = new Image(); im.className = 'lhs-rot__img'; im.alt = ''; im.decoding = 'async'; im.sizes = sizes; im.srcset = d.srcset; im.src = d.src; im.dataset.alt = d.alt || ''; d._img = im; return im; };
    const ready = im => im.complete && im.naturalWidth ? Promise.resolve() : new Promise(r => { im.onload = im.onerror = () => r(); });
    const step = async () => {
      timer = 0; if (!vis || document.hidden) return;
      const k = (i + 1) % list.length, im = make(k);
      await ready(im); if (!vis) return;
      if (!im.isConnected) box.append(im);
      requestAnimationFrame(() => { im.classList.add('is-on'); if (cur && cur !== im) { const old = cur; setTimeout(() => old.classList.remove('is-on'), 1000); } cur = im; i = k;
        if (first) first.setAttribute('alt', im.dataset.alt || first.alt);
        make((k + 1) % list.length); /* preload the next one */
        schedule(); });
    };
    const schedule = () => { clearTimeout(timer); if (vis) timer = setTimeout(step, 3600 + n * 400); };
    new IntersectionObserver(es => { vis = es[0].isIntersecting; if (vis) { if (i < 0) make(0); schedule(); } else { clearTimeout(timer); timer = 0; } }, { rootMargin: '100px 0px' }).observe(box);
    document.addEventListener('visibilitychange', () => { if (!document.hidden && vis) schedule(); });
  });

  /* (2) reviews: infinite loop (aria-hidden clones), slow drift, native swipe momentum on touch, mouse drag with momentum on desktop */
  const car = root.querySelector('[data-lhs-car]'), track = car?.querySelector('[data-lhs-car-track]');
  if (!track) return;
  track.addEventListener('click', e => {
    const b = e.target.closest('[data-lhs-more]'); if (!b) return;
    const card = b.closest('.lhs-review'), open = !card.classList.contains('is-open');
    card.classList.toggle('is-open', open); b.setAttribute('aria-expanded', String(open)); b.textContent = open ? 'Show less' : 'Read more';
    hold(open ? 1e9 : 1500);
  });
  const originals = [...track.children];
  if (originals.length < 2) return;
  originals.forEach(c => { const k = c.cloneNode(true); k.setAttribute('aria-hidden', 'true'); k.removeAttribute('id'); k.querySelectorAll('[id]').forEach(x => x.removeAttribute('id')); k.querySelectorAll('button').forEach(x => { x.tabIndex = -1; x.removeAttribute('aria-controls'); }); track.append(k); });
  let half = 0; const measure = () => { half = track.children[originals.length].offsetLeft - track.children[0].offsetLeft; };
  measure(); addEventListener('resize', measure, { passive: true });
  const wrap = () => { if (half > 0 && track.scrollLeft >= half + 2) track.scrollLeft -= half; };
  track.addEventListener('scroll', wrap, { passive: true });
  let vis = false, until = 0, raf = 0, last = 0, acc = 0, dragging = false;
  const hold = ms => { until = performance.now() + ms; };
  const SPEED = 22; /* px per second */
  const tick = t => {
    raf = 0; if (!vis || reduce) return;
    const dt = last ? Math.min(64, t - last) : 16; last = t;
    if (t > until && !dragging && !document.hidden) { acc += SPEED * dt / 1000; const px = Math.floor(acc); if (px) { acc -= px; track.scrollLeft += px; } }
    raf = requestAnimationFrame(tick);
  };
  const run = () => { if (!raf && vis && !reduce) { last = 0; raf = requestAnimationFrame(tick); } };
  new IntersectionObserver(es => { vis = es[0].isIntersecting; if (vis) run(); }, { rootMargin: '0px' }).observe(track);
  /* pause: touch, hover, keyboard focus */
  track.addEventListener('touchstart', () => hold(4000), { passive: true });
  track.addEventListener('touchmove', () => hold(4000), { passive: true });
  track.addEventListener('wheel', () => hold(3000), { passive: true });
  track.addEventListener('mouseenter', () => hold(1e9));
  track.addEventListener('mouseleave', () => hold(600));
  track.addEventListener('focusin', () => hold(1e9));
  track.addEventListener('focusout', () => hold(1500));
  track.addEventListener('keydown', e => { if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') { e.preventDefault(); const w = originals[0].offsetWidth + 16; track.scrollBy({ left: e.key === 'ArrowRight' ? w : -w, behavior: reduce ? 'auto' : 'smooth' }); } });
  /* mouse drag with momentum (touch uses the browser's own momentum scrolling) */
  let x0 = 0, s0 = 0, vx = 0, lt = 0, lx = 0, moved = 0;
  track.addEventListener('pointerdown', e => { if (e.pointerType !== 'mouse' || e.button !== 0) return; dragging = true; moved = 0; x0 = lx = e.clientX; s0 = track.scrollLeft; vx = 0; lt = performance.now(); track.setPointerCapture(e.pointerId); });
  track.addEventListener('pointermove', e => { if (!dragging) return; const now = performance.now(), dx = e.clientX - lx; vx = 0.8 * (dx / Math.max(1, now - lt)) + 0.2 * vx; lx = e.clientX; lt = now; moved += Math.abs(dx); if (moved > 4) track.classList.add('is-drag'); let sl = s0 - (e.clientX - x0); if (half > 0) { while (sl < 0) { sl += half; s0 += half; } } track.scrollLeft = sl; });
  const end = () => { if (!dragging) return; dragging = false; track.classList.remove('is-drag'); hold(2500); let v = -vx * 16; const glide = () => { if (Math.abs(v) < 0.5 || dragging) return; track.scrollLeft += v; v *= 0.94; requestAnimationFrame(glide); }; if (!reduce) requestAnimationFrame(glide); };
  track.addEventListener('pointerup', end); track.addEventListener('pointercancel', end);
  /* swiping backwards past the first card wraps too */
  track.addEventListener('scroll', () => { if (half > 0 && track.scrollLeft < 2 && !dragging) track.scrollLeft += half; }, { passive: true });
})();
});
